import { motion } from "framer-motion";
import trainingImg1 from "../../assets/images/training/trainingImg15.JPG";
import trainingImg2 from "../../assets/images/training/trainingImg8.JPG";
import trainingImg3 from "../../assets/images/training/trainingImg11.JPG";

/* ================= FLOAT ANIMATION ================= */

const floatCard = {
  initial: { y: 0 },
  animate: {
    y: [0, -8, 0],
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

/* ================= CARD POSITIONS (PIXEL MATCH OLD SCALE) ================= */

const cardPositions = [
  {
    id: "back",
    image: trainingImg3,
    inset: 14,        // ≈ scale 1.05
    x: -195,
    y: 35,
    rotate: -6,
    border: "border-white/10",
    shadow: "shadow-2xl",
    z: 1,
  },
  {
    id: "mid",
    image: trainingImg2,
    inset: 0,         // ≈ scale 1.08 (largest)
    x: 0,
    y: 0,
    rotate: 0,
    border: "border-white/15",
    shadow: "shadow-2xl",
    z: 2,
  },
  {
    id: "top",
    image: trainingImg1,
    inset: 8,         // ≈ scale 1.05
    x: 180,
    y: -24,
    rotate: 7,
    border: "border-white/20",
    shadow: "shadow-[0_40px_120px_rgba(0,0,0,0.75)]",
    z: 3,
  },
];

/* ================= CARD COMPONENT ================= */

function TrainingCard({ data, isTop }) {
  return (
    <motion.div
      initial={{
        x: data.x * 0.85,   // 🔑 start closer
        y: data.y * 0.85,
        rotate: data.rotate * 0.6,
      }}
      animate={{
        x: data.x,
        y: data.y,
        rotate: data.rotate,
      transition: {
        type: "spring",
        stiffness: 10,
        damping: 7,
        delay: data.z * 0.05,
      }
      }}
      style={{ zIndex: data.z }}
      className="absolute inset-0"
    >
      {/* SIZE WRAPPER */}
      <div
        className="absolute"
        style={{ inset: `${data.inset}px` }}
      >
        <motion.div
          {...(!isTop ? floatCard : {})}
          className={`
            relative h-full w-full overflow-hidden rounded-3xl
            border ${data.border} ${data.shadow}
          `}
        >
          {/* Background */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${data.image})` }}
          />

          {/* TOP CARD CONTENT */}
          {isTop && (
            <div className="relative z-10 flex h-full flex-col justify-between p-6 text-white">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium">
                  High-Altitude Skills & Safety
                </span>
                <span className="rounded-full border border-white/30 px-2 py-0.5 text-[10px] uppercase">
                  Active
                </span>
              </div>

              <div className="text-[11px] text-neutral-300">
                Skills · Safety · Endurance
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
}


/* ================= MAIN SECTION ================= */

export default function TrainingHeroPage() {
  return (
    <section className="relative min-h-screen bg-transparent px-4 pt-44 pb-40">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 lg:grid-cols-2 lg:items-center">

        {/* LEFT : CARD STACK */}
        <div className="relative overflow-visible">
          <div
            className="
              relative mx-auto flex items-center justify-center
              h-[clamp(380px,62vh,560px)]   /* 🔑 slightly larger */
              w-[clamp(300px,44vw,560px)]  /* 🔑 matches old perceived size */
              select-none
            "
          >
            {cardPositions.map((card) => (
              <TrainingCard
                key={card.id}
                data={card}
                isTop={card.id === "top"}
              />
            ))}
          </div>
        </div>

        {/* RIGHT : TEXT */}
        <div className="flex flex-col items-end gap-4 text-right">
          <h1 className="text-[64px] font-semibold leading-none tracking-tight text-white/50 sm:text-[72px] md:text-[80px] lg:text-[96px]">
            TRAINING
          </h1>
          <h1 className="text-[64px] font-semibold leading-none tracking-tight text-white sm:text-[72px] md:text-[80px] lg:text-[96px]">
            PROGRAMS
          </h1>

          <p className="text-2xl font-medium tracking-wide text-gray-200">
            High-Altitude Training Pathway
          </p>
          <div className="mt-2 h-[1px] w-10 bg-white/60" />
        </div>

      </div>
    </section>
  );
}
